import { supabase } from "~/integrations/supabase/client";
import { SalesRequest, SalesRequestItem } from "~/types/client";

export const fetchSalesRequestItemsUtil = async (
  requests: SalesRequest[]
): Promise<Record<string, SalesRequestItem[]>> => {
  try {
    const itemsMap: Record<string, SalesRequestItem[]> = {};

    // If no requests, return empty object
    if (!requests || requests.length === 0) {
      return itemsMap;
    }

    // Get unique request IDs
    const requestIds = [...new Set(requests.map((req) => req.id))];

    // Fetch all items for these requests in a single query
    const { data: itemsData, error: itemsError } = await supabase
      .from("sales_request_items")
      .select(
        `
        id,
        sales_request_id,
        product_id,
        quantity,
        unit_price,
        discount_percent,
        created_at,
        products:product_id (
          unit_code,
          base_measurement_unit,
          group_description
        )
      `
      )
      .in("sales_request_id", requestIds);

    if (itemsError) throw itemsError;

    if (itemsData) {
      // Group items by sales_request_id
      itemsData.forEach((item) => {
        const salesRequestId = item.sales_request_id;

        if (!itemsMap[salesRequestId]) {
          itemsMap[salesRequestId] = [];
        }

        itemsMap[salesRequestId].push({
          id: item.id,
          salesRequestId: item.sales_request_id,
          productId: item.product_id,
          quantity: item.quantity,
          unitPrice: item.unit_price,
          discountPercent: item.discount_percent ?? undefined,
          createdAt: item.created_at,
          unit:
            (item.products as any)?.unit_code ||
            (item.products as any)?.base_measurement_unit,
          group: (item.products as any)?.group_description ?? undefined,
        });
      });
    }

    return itemsMap;
  } catch (error) {
    console.error("Error fetching sales request items:", error);
    return {};
  }
};
